<template>
  <div class="task-authority">
    <header class="top-wrap">
      <div class="main-title">任务权限</div>
      <div class="right">
        <el-button type="primary" size="small" @click="save">保存</el-button>
      </div>
    </header>
    <main class="main-wrap">
      <div>
        <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
        <BaseTable
          v-else
          ref="BaseTable"
          tableHeight="auto"
          :tableData="tableData"
          :showPagination="false"
        >
          <el-table-column prop="name" label="任务权限" align="center"></el-table-column>
          <el-table-column
            v-for="role in roleList"
            :key="role.value"
            :label="role.name"
            align="center"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row[role.value]"
                @change="checkChange(scope.row, role, $event)"
              ></el-checkbox>
              <base-button
                v-if="scope.row.name === '编辑'"
                type="text"
                @click="openFieldPri(role.value)"
                class="btn-set-field-pri"
              >
                设置字段权限
              </base-button>
            </template>
          </el-table-column>
        </BaseTable>
        <div class="create-table">
          <div class="create-table-left">新建</div>
          <div class="create-table-right">
            <el-radio v-model="checkAll" :label="true">全部角色</el-radio>
            <el-radio v-model="checkAll" :label="false">指定角色</el-radio>
            <el-select
              v-if="!checkAll"
              v-model="checkedRoles"
              filterable
              multiple
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in roles"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </main>
    <fields-privilege ref="FieldsPrivilege" @submit="setFieldPri"></fields-privilege>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseComponents/Table"
import BaseButton from "@/components/UIComponents/Button"
import FieldsPrivilege from "./SettingFieldPri"
import { updateProjectPrivilege } from "@/api/project/project"
import { getPrisTableData, roleList, transPrisTableData } from "@/utils/project"
import { loadingService } from "@/utils/ui"
import * as ProjectApi from "@/api/project/project"

export default {
  name: "task-authority",
  components: { BaseTable, BaseButton, FieldsPrivilege },
  props: {
    projectInfo: Object
  },
  watch: {
    projectInfo() {
      if (this.projectInfo) {
        this.initPri()
      }
    }
  },
  computed: {
    privileges() {
      return this.projectInfo?.privilege?.privileges || {}
    }
  },
  data() {
    return {
      roleList,
      showTable: false,
      tableData: [],
      checkAll: true,
      checkedRoles: [],
      roles: [],
      pageInfo: {
        total: 1000,
        currentPage: 1,
        pageSize: 20
      },
      publicMode: true,
      curFieldType: null,
      fieldPris: {}
    }
  },
  created() {
    this.initPri()
  },
  methods: {
    async initPri() {
      this.tableData = getPrisTableData(this.privileges)
      let roleList = this.projectInfo?.privilege?.roleList
      if (roleList == null || roleList.length === 0) this.checkAll = true
      else {
        this.checkAll = false
        this.checkedRoles = roleList
      }
      Array.of("ASSIGNEE", "CREATOR", "PARTICIPANT").forEach(role => {
        this.fieldPris[role] = (this.privileges[role] || 0) & 0xffff0000
      })
      if (this.projectInfo.id !== undefined) {
        await ProjectApi.getAllProjectRole(this.projectInfo.id).then(res => {
          this.roles = res
        })
      }
      this.publicMode = this.projectInfo?.privilege?.publicMode
      this.showTable = true
    },
    openFieldPri(curFieldType) {
      this.curFieldType = curFieldType
      this.$refs.FieldsPrivilege.open(this.fieldPris[this.curFieldType])
    },
    setFieldPri(fieldPriCode) {
      this.fieldPris[this.curFieldType] = fieldPriCode
    },
    save() {
      // 基本权限
      let updatedPris = transPrisTableData(this.tableData)
      // 字段权限
      Array.of("ASSIGNEE", "CREATOR", "PARTICIPANT").forEach(role => {
        updatedPris[role] |= this.fieldPris[role]
      })
      let loadingInstance = loadingService()
      let roleList = this.checkAll ? null : this.checkedRoles
      updateProjectPrivilege(updatedPris, this.projectInfo?.id, this.publicMode, roleList).then(
        res => {
          loadingInstance.close()
          this.$message.success("更新成功！")
          this.$emit("refresh-project")
        }
      )
    },
    checkChange(row, col, checked) {
      if (row.name === "编辑") {
        if (checked) {
          this.fieldPris[col.value] = this.fieldPris[col.value] | 0xffff0000
        } else {
          this.fieldPris[col.value] = this.fieldPris[col.value] & 0x0000ffff
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.task-authority {
  .main-wrap {
    height: calc(100% - 56px) !important;
    overflow-y: auto;
    overflow-x: hidden;
    .btn-set-field-pri {
      position: absolute;
      right: 25px;
      top: 2px;
    }
    .create-table {
      width: 100%;
      display: flex;
      font-size: 14px;
      line-height: 23px;
      border: 1px solid #ebeef5;
      border-top: none;
      min-height: 40px;
      .create-table-left {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .create-table-right {
        position: relative;
        left: 1px;
        padding: 10px 0;
        border-left: 1px solid #ebeef5;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 3;
        .el-select {
          width: 300px;
        }
      }
    }
  }
}
</style>
